import { useUnit } from 'effector-react';
import { Button, ConfigProvider, Descriptions } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import {
  $popupData,
  $projectModal,
  $regionsDict,
  changeProjectModalEv,
  resetPopupDataEv,
} from '../../../models/investProModel/index.js';
import style from './DotPopup.module.css';
import { popup_props_transaltion } from '../../../dictionaries/popup_props_translation.js';
import { addSeparators } from '../../../utils/format-utils.js';
import { CHTheme } from '../../../theme/themeConfig.js';

function DotPopup() {
  const popupData = useUnit($popupData);
  const resetPopupData = useUnit(resetPopupDataEv);
  const changeProjectModal = useUnit(changeProjectModalEv);
  const projectModal = useUnit($projectModal);
  const regionsDict = useUnit($regionsDict);
  const onClose = () => {
    resetPopupData();
  };

  const formatData = () => {
    let propsToShow = [];
    switch (popupData.properties.source) {
      case 'regions_with_population':
        {
          if (popupData.properties.code.length === 6) {
            propsToShow = [
              'lvl_1_code',
              'lvl_2_code',
              'total_population',
              'count_household',
              'income',
              // 'vrp_mln_tg',
              'VRP',
              'unemployment_rate',
              'inflation',
            ];
          } else {
            propsToShow = [
              'lvl_1_code',
              'lvl_2_code',
              'total_population',
              'count_household',
            ];
          }
        }
        break;
      case 'test_invest_points':
        {
          propsToShow = [
            'name_ru',
            'gen_name',
            'investment_sum',
            'nvp_sum',
            'irr',
            'ebitda',
            'payback_period',
          ];
        }
        break;
      case 'alta_railway':
        {
          propsToShow = ['title'];
        }
        break;
      case 'kz_airports':
      case 'ferry_terminals':
        {
          propsToShow = ['name'];
        }
        break;
      case 'minres':
        {
          propsToShow = ['mineraldeveloper'];
        }
        break;
      case 'sez_raw_zone':
      case 'sez_raw_zone_center':
      case 'iz_raw_zone_center':
        {
          propsToShow = ['name'];
        }
        break;
      default:
        {
          switch (popupData.source) {
            case 'invest_pro_warehouse_source':
              {
                propsToShow = ['name', 'search_rubric', 'address', 'schedule'];
              }
              break;
            case 'invest_pro_sto_source':
              {
                propsToShow = ['name', 'search_rubric', 'address', 'schedule'];
              }
              break;
            case 'invest_pro_azs_source':
              {
                propsToShow = ['name', 'search_rubric', 'address', 'schedule'];
              }
              break;
            default:
              break;
          }
        }
        break;
    }

    propsToShow = propsToShow.filter((item) => {
      return popupData.properties[item];
    });

    return propsToShow.map((item) => {
      let children = popupData.properties[item];
      if (item === 'lvl_1_code' || item === 'lvl_2_code') {
        children = regionsDict[children].name;
      }
      if (!Number.isNaN(Number(children))) {
        children = addSeparators(Number(children));
      }

      return {
        key: item,
        label: popup_props_transaltion[item],
        children: children || '-',
      };
    });
  };

  if (!popupData) return null;

  const detailsButton =
    popupData.properties.source !== 'ferry_terminals' &&
    !popupData.source.includes('azs') &&
    !popupData.source.includes('warehouse') &&
    !popupData.source.includes('sto');

  return (
    <div
      className={[
        style.dot_popup,
        'glass',
        projectModal ? style.move : style.default,
      ].join(' ')}
    >
      <Button
        icon={<CloseOutlined />}
        className={[style.close_button, 'glass'].join(' ')}
        shape="circle"
        onClick={onClose}
      />
      <Descriptions
        items={formatData()}
        column={1}
        size="small"
        layout="vertical"
      />
      {detailsButton && (
        <Button
          onClick={() => changeProjectModal(popupData)}
          className={[style.details_button, 'glass'].join(' ')}
        >
          Подробнее
        </Button>
      )}
    </div>
  );
}

export default DotPopup;
